var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"gameEndedRef",attrs:{"hide-footer":"","no-close-on-backdrop":""}},[_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('b-btn',{on:{"click":_vm.newGame}},[_vm._v("New Game")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-025647d7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameEndedModal.vue
// module id = null
// module chunks = 